import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Clock, Thermometer } from 'lucide-react';
export function RecognitionSection() {
  return <section className="w-full bg-[#0F1923] py-20 px-6" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16 text-center md:text-left" data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-bold text-[#F5E6D0] mb-6 font-sans" data-id="element-136">
            ¿Para quién es esto?
          </h2>
          <p className="text-xl text-[#B8A99A] font-serif leading-relaxed" data-id="element-137">
            Para adultas de 40 o más, que se despiertan a las 3–4am varias
            noches por semana, a veces con calor, a veces con ansiedad, y ya
            están cansadas de tips genéricos que no sirven a esa hora.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-[#1B2838]/50 p-8 md:p-12 rounded-2xl border border-[#B8A99A]/10" data-id="element-138">
          <h3 className="text-2xl font-bold text-[#F5E6D0] mb-8 font-sans flex items-center gap-3" data-id="element-139">
            <Moon className="w-6 h-6 text-[#E8614D]" data-id="element-140" />
            Si esto te pasa, lo vas a reconocer:
          </h3>

          <ul className="space-y-6" data-id="element-141">
            {['Te despiertas y lo primero que haces es… evaluar el daño.', 'Miras el reloj (aunque juras que no lo harás).', "Empiezas a negociar: 'si me duermo ya, todavía alcanzo 4 horas…'", 'Te cambias de lado 20 veces.', 'Y el calor y la mente se turnan para mantenerte en vigilancia.'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 * index,
            duration: 0.5
          }} className="flex items-start gap-4 text-[#B8A99A] text-lg font-serif" data-id="element-142">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#E8614D] flex-shrink-0" data-id="element-143" />
                <span data-id="element-144">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-145">
          <p className="text-[#F5E6D0] text-xl font-serif italic opacity-80" data-id="element-146">
            Al día siguiente, haces lo que puedes. Pero por dentro estás
            pensando:
            <br data-id="element-147" />
            <span className="text-[#E8614D] not-italic font-medium mt-2 block" data-id="element-148">
              "¿Hoy otra vez? ¿Cuánto tiempo voy a aguantar así?"
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}